import { useContext } from 'react';
import { SheetVisibilityContext } from './SheetVisibilityContext';

export const useSheetVisibility = () => {
    const context = useContext(SheetVisibilityContext);

    if (!context) {
        throw new Error('useSheetVisibility must be used within SheetVisibilityProvider');
    }

    return context;
};
